import client from '../base-api';

const serviceURL = '/address-book/partner-practices';

const addressBookPartnerPracticesService = {

    getPartnerPractices(filterData: any) {
        return client.get(`${serviceURL}`, {params: filterData});
    },

    getSinglePartnerPractice(id: number) {
        return client.get(`${serviceURL}/${id}`);
    },

    postPartnerPractice(data: any) {
        return client.post(`${serviceURL}`, data);
    },

    putPartnerPractice(data: any, id: number) {
        return client.put(`${serviceURL}/${id}`, data);
    },

    deletePartnerPractice(id: number) {
        return client.put(`${serviceURL}/delete/${id}`);
    },
};

export default addressBookPartnerPracticesService;
  